// Mock data for The Fleetwood Mac Experience clone

export const navLinks = [
  { label: 'HOME', href: '#home' },
  { label: 'ABOUT', href: '#about' },
  { label: 'THE BAND', href: '#band' },
  { label: 'SETLIST', href: '#setlist' },
  { label: 'GALLERY', href: '#gallery' },
  { label: 'DATES', href: '#dates' },
];

export const heroImage =
  'https://customer-assets.emergentagent.com/job_custom-domain-app-7/artifacts/uuvloe8e_476680593_122139704438539067_2058228668213319627_n.jpg';

export const logoWhite =
  'https://customer-assets.emergentagent.com/job_custom-domain-app-7/artifacts/kcjy96ho_FM_whitetext.png';

export const storyImage =
  'https://static.wixstatic.com/media/06cbfc_df68a4faa16147ee86d04210aea91016~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/06cbfc_df68a4faa16147ee86d04210aea91016~mv2.jpg';

export const bandMembers = [
  {
    name: 'Carly Cook',
    role: 'Vocals / Percussion',
    as: 'as Stevie Nicks',
    image:
      'https://static.wixstatic.com/media/06cbfc_560f30b83f5f457e90385a7112c1a45f~mv2.jpg/v1/fill/w_400,h_420,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Fleetwood_Mac-32_edited.jpg',
    bio: 'Captivating stage presence and that unmistakable Stevie shimmer — twirling shawls and all.',
  },
  {
    name: 'Laura Sheppard',
    role: 'Vocals / Keyboards',
    as: 'as Christine McVie',
    image:
      'https://static.wixstatic.com/media/06cbfc_d7dd10022ade46dfa0374fd0176a31e4~mv2.jpg/v1/fill/w_400,h_420,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Fleetwood_Mac-30_edited.jpg',
    bio: "Smoky vocals and Christine's soulful keys — the warm heart of the band.",
  },
  {
    name: 'Alan Howell',
    role: 'Vocals / Guitars',
    as: 'as Lindsey Buckingham',
    image:
      'https://static.wixstatic.com/media/06cbfc_8b83d24857ca47b0aebcbae0161d24fd~mv2.jpg/v1/fill/w_400,h_420,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Fleetwood_Mac-25_edited_edited.jpg',
    bio: "Fingerpicking wizardry and powerhouse vocals — Lindsey's fire on stage.",
  },
  {
    name: 'David Graham',
    role: 'Bass',
    as: 'as John McVie',
    image:
      'https://static.wixstatic.com/media/06cbfc_dd340fc4e5d340fcb98e9cc589b9d5ed~mv2.jpg/v1/fill/w_400,h_420,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Fleetwood_Mac-27%20(1)_edited.jpg',
    bio: 'Locked-in grooves and the steady pulse that anchors every song.',
  },
  {
    name: 'Tom Bevan',
    role: 'Drums',
    as: 'as Mick Fleetwood',
    image:
      'https://static.wixstatic.com/media/06cbfc_5cfdc9ff80264c0ba93f3b47414c93dc~mv2.jpg/v1/fill/w_400,h_420,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Fleetwood_Mac-41_edited_edited.jpg',
    bio: "Towering presence behind the kit — channelling Mick's tribal swing.",
  },
];

export const galleryImages = [
  'https://static.wixstatic.com/media/06cbfc_7938a6ea1fd540cfba3a0266a1f14b6f~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_7938a6ea1fd540cfba3a0266a1f14b6f~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_fd2b4bdf301a4bb1bc7cdcf182ea12e2~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_fd2b4bdf301a4bb1bc7cdcf182ea12e2~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_d2f87fe0772c4aa0b7fc89ea8524899a~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_d2f87fe0772c4aa0b7fc89ea8524899a~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_a168661db0754e84a3231f4e14b653a5~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_a168661db0754e84a3231f4e14b653a5~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_bb1e48a813ac45bcbc806b9811116d57~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_bb1e48a813ac45bcbc806b9811116d57~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_1e5f837a8e0b4d10a55a59994980872d~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_1e5f837a8e0b4d10a55a59994980872d~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_dc6440a4e19b4849a4a76b6ae0f93bfb~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_dc6440a4e19b4849a4a76b6ae0f93bfb~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_7c18ce8fc563476ebc24ba00ef3b1349~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_7c18ce8fc563476ebc24ba00ef3b1349~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_ff7bed9e55e14afe849c84857a835541~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_ff7bed9e55e14afe849c84857a835541~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_f056e865e4624dcdb5f80c8a476f8e78~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_f056e865e4624dcdb5f80c8a476f8e78~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_5b0594b425534d8f81dcc7f048ee74c7~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_5b0594b425534d8f81dcc7f048ee74c7~mv2.jpg',
  'https://static.wixstatic.com/media/06cbfc_5c330df104ce4d7297c24af0bd7a0a2b~mv2.jpg/v1/fill/w_600,h_400,q_80,enc_avif,quality_auto/06cbfc_5c330df104ce4d7297c24af0bd7a0a2b~mv2.jpg',
];

export const stats = [
  { value: '5', label: 'Musicians' },
  { value: '25+', label: 'Setlist Classics' },
  { value: '1', label: 'Unforgettable Night' },
];

export const setlist = [
  { title: 'Dreams', era: 'Rumours, 1977' },
  { title: 'Go Your Own Way', era: 'Rumours, 1977' },
  { title: 'The Chain', era: 'Rumours, 1977' },
  { title: 'Rhiannon', era: 'Fleetwood Mac, 1975' },
  { title: "Don't Stop", era: 'Rumours, 1977' },
  { title: 'Landslide', era: 'Fleetwood Mac, 1975' },
  { title: 'Little Lies', era: 'Tango in the Night, 1987' },
  { title: 'Everywhere', era: 'Tango in the Night, 1987' },
  { title: 'Gold Dust Woman', era: 'Rumours, 1977' },
  { title: 'Big Love', era: 'Tango in the Night, 1987' },
  { title: 'Gypsy', era: 'Mirage, 1982' },
  { title: 'You Make Loving Fun', era: 'Rumours, 1977' },
];

export const testimonial = {
  quote:
    "I've seen several Fleetwood Mac tribute bands but you are the guys who really rock both the look and sound.",
  author: 'Lenny Castro',
  title: 'Percussionist for Stevie Nicks & Toto',
};

export const faqs = [
  {
    q: 'What kind of events do you play?',
    a: "Theatres, concert halls, festivals, corporate events, weddings, anniversaries and private parties. Whether it's an intimate venue or a larger theatre, we tailor the show to the room.",
  },
  {
    q: 'How long is a typical show?',
    a: 'Our standard performance is two 45-minute sets with a 20-minute interval, but we can adapt for shorter slots (festivals) or a single longer set on request.',
  },
  {
    q: 'Do you bring your own PA and lighting?',
    a: 'For most theatre and venue shows we use the house rig. For corporate, weddings and private events we can supply a full professional PA and stage lighting package — just let us know your venue size.',
  },
  {
    q: 'How far will you travel?',
    a: "We're based in London and play UK-wide. International bookings are absolutely welcome — get in touch and we'll send a tailored quote.",
  },
  {
    q: 'Can you learn a special-request song?',
    a: "We cover 25+ Fleetwood Mac classics from across the catalogue. For first-dance or special-occasion requests outside our regular set, just ask — we'll often say yes.",
  },
  {
    q: 'How do I book you?',
    a: "Drop us a message using the booking form, or email info@davidgrahamentertainment.com with your date, venue and any details. We'll come back to you within 24 hours.",
  },
];

// Upcoming tour dates — synced from the live base44 site
export const tourDates = [
  { id: 'td-2026-07-25', date: '2026-07-25', venue: 'Winters Tale Sundown', city: 'Winters Tale Country Barn, Buckingham', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2026-08-15', date: '2026-08-15', venue: 'Stansted Mountfitchet Social Club', city: 'Stansted', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2026-09-06', date: '2026-09-06', venue: 'Highcliffe', city: 'Highcliffe', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2026-09-17', date: '2026-09-17', venue: 'Pebble Beach Restaurant', city: 'Barton on Sea', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2026-11-07', date: '2026-11-07', venue: 'Crockenhill', city: 'Crockenhill', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2026-11-21', date: '2026-11-21', venue: 'Concorde Club', city: 'Eastleigh', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2026-12-16', date: '2026-12-16', venue: 'Pebble Beach Restaurant', city: 'Barton on Sea', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2026-12-19', date: '2026-12-19', venue: 'Cliffhanger Restaurant', city: 'Highcliffe', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2026-12-20', date: '2026-12-20', venue: 'Concorde Club', city: 'Eastleigh', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2027-01-30', date: '2027-01-30', venue: 'New Vic Theatre', city: 'Newcastle-under-Lyme', country: 'UK', ticketUrl: '#', soldOut: false },
  { id: 'td-2027-03-05', date: '2027-03-05', venue: 'The Kenton', city: 'Henley-on-Thames', country: 'UK', ticketUrl: '#', soldOut: false },
];

export const pastShows = [
  { id: 'ps-2026-05-29', date: '2026-05-29', venue: 'Cliffhanger Restaurant', city: 'Highcliffe', country: 'UK' },
  { id: 'ps-2026-06-01', date: '2026-06-01', venue: 'New Vic Theatre', city: 'Newcastle-under-Lyme', country: 'UK' },
];

export const contactInfo = {
  phone: '07711 894 826',
  phoneRaw: '07711894826',
  email: 'info@davidgrahamentertainment.com',
  addressLines: [
    'David Graham Entertainment Ltd',
    '3rd Floor, 14 Hanover Street',
    'London, W1S 1YH',
  ],
  social: {
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com',
    tiktok: 'https://tiktok.com',
    youtube: 'https://www.youtube.com/@thefleetwoodmacexperience',
  },
};
